import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { combineLatest, concat, fromEvent, iif, MonoTypeOperatorFunction, Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PageVisibilityService {
  constructor(@Inject(DOCUMENT) public document: Document) {}

  visibleChanges(): Observable<boolean> {
    const visibilityChanges = fromEvent(this.document, 'visibilitychange');
    return concat(of(null), visibilityChanges).pipe(map(() => !this.document.hidden || this.document.hasFocus()));
  }

  onVisible<T>(): MonoTypeOperatorFunction<T> {
    return (source) =>
      combineLatest([source, this.visibleChanges()]).pipe(
        filter(([, isVisible]) => isVisible),
        map(([data]) => data)
      );
  }

  toggleOnVisible<T>(): MonoTypeOperatorFunction<T> {
    return (source) =>
      this.visibleChanges().pipe(
        switchMap((isVisible) => iif(() => isVisible, source, of<T>()))
      );
  }
}
